<template>
  <div>
    <!-- <training-header></training-header> -->
    <div class="mdgridviewpage-bg">
      <!-- <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12"></div>
        </div>
      </div> -->
      <div class="container-fluid m-t-10px">
        <div class="row dashboardchart-container globalconfigcontainer">
          <div class="col-lg-8" style="margin:0 auto;">
            <div class="card m-b-20px m-t-20px">
              <!-- <div
                class="card-header text-decoration-none p-l-16px p-12px"
                id="headingOne"
              >
                 Activate an Account
              </div> -->
              <div class="collapse show" aria-labelledby="headingOne">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <div class="card-header" style="background-color:rgba(221, 221, 221, 0.91) !important;">
                      <div class="row d-flex">
                        <div class="col-md-8 mx-auto">
                          <div class="row">
                            <div class="col-sm-4">
                              <img v-if="settings.countryName.toLowerCase() === 'nepal' " src="../assets/img/Nepal_logo.png" class="imgFit float-right" style="padding-top: 3%; height: 65px;">
                              <img v-else src="../assets/img/logo_front_new.png" class="imgFit float-right pr-3" style="padding-top: 3%;"> 
                            </div>
                            <div class="col-sm-8 perfect-center float-left" style="justify-content: left;">
                              <h4 style="margin-bottom: 0;font-weight:400;"><span style="font-weight:600;">Family Planning</span> Dashboard</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div class="card-body c-body p-40px">
                    <form @submit.prevent="handleSubmit(onSubmit)" class="d-flex">
                      <div class="row col-lg-8" style="margin: 0 auto;">
                        <h4 class="inner-heading text-center pt-2 pb-1 w-100" style="font-weight: 400;">
                          Welcome
                        </h4>
                        <div class="mainform-holder w-100">
                          <div class="col-lg-12">
                            
                            <div class="form-group row">
                              <label
                                for="inputContactEmail"
                                class="col-sm-4 col-form-label"
                                >E-mail</label
                              >
                              <div class="col-sm-8">
                                <ValidationProvider name="E-mail" rules="required|email" v-slot="{ errors }">
                                  <input 
                                    v-model="email" 
                                    type="email"
                                    class="form-control bg-grey"
                                    id="inputContactEmail"
                                    placeholder=""
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="form-group row">
                              <label
                                for="inputToken"
                                class="col-sm-4 col-form-label"
                                >Token</label
                              >
                              <div class="col-sm-8">
                                <ValidationProvider name="Token" rules="required" v-slot="{ errors }">
                                  <input
                                    v-model="token"
                                    type="text"
                                    class="form-control bg-grey"
                                    id="inputToken"
                                    placeholder=""
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mt-3">
                                <div class="row">
                                  <div class="col-lg-4 col-sm-4">
                                    
                                  </div>
                                  <div class="col-lg-8 col-sm-8">
                                    <div class="row">
                                      <div class="form-group mb-0">
                                      <div class="col text-right" style="padding-left: 11px;">
                                        <button type="submit" class="btn btn-primary black-btn color-white" style="padding: 6px 35px; float: right; margin-right: 0px;">Activate Account</button>
                                      
                                      </div>
                                    </div>
                                    <div class="form-group mb-0">
                                      <div class="col text-left m-t-10px">
                                        <a class="" @click="GotoSignin()" style="font-size: 14px;">Sign In</a>
                                      </div>
                                    </div>
                                    </div>
                                    
                                  </div>
                                </div>
                              </div>
                          <!-- <div class="col-lg-12">
                            <div class="row">
                              
                            </div>
                          </div> -->
                  
                        </div>
                      </div>
                    </form>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <training-footer></training-footer>
  </div>
</template>

<script>
import { extend } from 'vee-validate';
import { required} from 'vee-validate/dist/rules';
import ApiServices from '../service/ApiServices';
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';

extend('required', {
  ...required,
  message: 'This field is required'
});
export default {
  name: "activation",
  props: {},
  components: {
        trainingHeader, 
        trainingFooter
    },
  data() {
    return {
      email:'',
      token: '',
      settings: settings
    };
  },
  methods: {
    onSubmit() {
      this.$root.loading = true;
      //let headers = {Authorization: 'Basic YWRtaW46ZGlzdHJpY3Q='};
      ApiServices.RestGetCall('api/avenir/subscribe/authorize',{"email":this.email,"token":this.token})
        .then(response =>{
          this.$root.loading = false;
          console.log(response);
          if(response.status.toLocaleLowerCase() == "success"){
            this.email=this.token='';
            this.$swal({
              text: response.message
            }).then(()=>{
              this.$router.push("/");
            });
            
          }else{
            this.$swal({
              text: response.message
            });
          }
        })  
    },
    GotoSignin(){
      this.$router.push("/");
    }
  }
};
</script>
<style lang="scss" scoped>
.mdgridviewpage-bg {
  background-color: #38a1c1;
  background: url("../assets/img/sign_bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
    padding: 20px 40px;
    display: flex;
    
    justify-content: center;
    align-items: center;
}

body.green-theme .mdgridviewpage-bg {
  background-color: #006600;
  background: url("../assets/img/green-bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  padding: 20px 40px;
}
.mainform-holder {
  /*background: #fff;
  -webkit-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  -moz-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  border-radius: 10px;*/
  padding: 15px 5px;
}
.c-body {
  background-color: rgba(255, 255, 255, 0.78) ;
  padding-top: 10px !important;
  padding-bottom: 30px !important;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  /* border-top-left-radius: 10px;
  border-top-right-radius: 10px; */
  /* box-shadow: 0px 0px 3px rgba(53,53,53,0.26); */
}


.card{
  background-color:transparent;
  box-shadow: 0px 0px 0px 0px 4px rgb(186, 186, 186) !important;
        border-radius: 10px;
        border: 0px !important;
}
.card-header{
        border-bottom: 0px;
        border-radius: 10px 10px 0 0 !important;
        padding:8px 12px !important;
    }
.form-control{
  background: #efeeee !important;
    border-color: #f2f2f2;
    color: #171a22 !important;
    font-size: 14px !important;
    font-weight: 200;
    border: 1px solid #e9e9e9;
}
a{
  cursor: pointer;
  color: rgb(121, 121, 121);

}
a:hover{
  text-decoration:underline !important;
}
input:-internal-autofill-selected {
  background: #ddd !important;
    border-color: #f2f2f2 !important;
}
*{
  color: #4c4c4c;
}
label{
  font-weight: 200;
}
</style>